exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-root {\n  height: calc(100vh - 55px);\n  width: 240px;\n  background-color: #28363D;\n  position: fixed; }\n\n.hidden {\n  display: none; }\n\n.route-item {\n  display: flex;\n  padding: 10px 0;\n  color: white;\n  align-items: center;\n  cursor: pointer; }\n  .route-item:hover {\n    background-color: #69BC73; }\n  .route-item svg {\n    flex-basis: 20%;\n    height: 10px; }\n  .route-item p {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 300;\n    flex-basis: 80%; }\n  .route-item.active {\n    background-color: #33444C; }\n", ""]);

// exports
